
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 * 聊天信息区 发送显示每条消息
 */
import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import UserChatItem from "@/components/messageInteraction/user-chat-item.vue";
import {SizeEnum} from "@/ts/Enum";
import ChatNotice from "@/components/messageInteraction/chat-notice.vue";

@Component({
  components: {ChatNotice, UserChatItem},
})
export default class ChatMessage extends Vue {
  @Prop() type: SizeEnum;
  @Prop() isNotice: boolean;
  @Prop() notice: string;
  @Prop() userList: [];
  @Prop({default: 780})
  height: number;


  @Ref("content") readonly content;
  @Ref("notice") readonly noticeRef;


  initContentHeight() {
    if (this.isMobile) {
      return
    }
    let elementById = document.getElementById("content");

    if (elementById) {
      if (this.isNotice) {
        let noticeHeight = this.noticeRef.$el.scrollHeight
        noticeHeight = parseInt(noticeHeight) + 40
        elementById.style.height = 'calc(100% - ' + noticeHeight + 'px)'
        // if (this.type === SizeEnum.medium) {
        // } else if (this.type === SizeEnum.small) {
        //   elementById.style.maxHeight = `calc(100% - 110px)`;
        //   elementById.style.minHeight = `calc(100% - 110px)``;
        // }
      } else {
        elementById.style.height = 'calc(100% - 40px)';
      }
    }


  }

  scrollTop() {
    this.$nextTick(() => {
      const scrollHeight = this.content.scrollHeight;
      var anchor = window.document.querySelector('#content')//获取元素
      if (anchor) {
        setTimeout(() => {
          anchor.scrollTop = scrollHeight
        }, 100)
      }
    })
  }


  @Watch("isNotice", {deep: true, immediate: false})
  isNoticeWatch() {
    this.$nextTick(() => {
      this.initContentHeight();
    })
  }
}
